module.exports = __webpack_public_path__ + "static/media/danger.09c15373.svg";